var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-form-checkbox',{attrs:{"switch":""},on:{"input":_vm.onFilterChange},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),(_vm.value !== null)?_c('i',{staticClass:"fas fa-trash",on:{"click":_vm.clearValue}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }